<template>
  <div id="suppliers">
    <div class="columns">
      <div class="column is-half">
        <div class="loading" v-if="loading">Laden...</div>

        <div class="error" v-if="errors">{{ errors }}</div>
      </div>

      <div class="column is-one-quarter is-one-quarter-offset">
        <router-link :to="{ name: 'supplier-edit' }" class="button">Nieuwe leverancier</router-link>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <ul>
          <router-link
            v-for="supplier in suppliers"
            :key="supplier.id"
            :to="{ name: 'supplier-edit', params: { id: supplier.id } }"
            tag="li"
          >{{ supplier.name }} - {{ userName(supplier.user) }}</router-link>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    data() {
      return {
        loading: false,
        suppliers: null,
        errors: null
      };
    },
    created () {
      this.fetchData()
    },
    methods: {
      fetchData () {
        this.error = this.suppliers = null
        this.loading = true
        axios
          .get('/suppliers')
          .then(response => {
            this.loading = false
            this.suppliers = response.data
          }).catch(error => {
            this.loading = false
            this.error = error.response.data.message || error.message
          });
      },
      fetchUsers () {
        this.error = this.users = null
        this.loading = true
        axios
          .get('/users')
          .then(response => {
            this.loading = false
            this.users = response.data
          }).catch(error => {
            this.loading = false
            this.error = error.response.data.message || error.message
          });
      },
      userName (user) {
        return (user) ? `${user.firstname} ${user.lastname}` : null
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/suppliers/Suppliers.vue